<mat-card>
    <mat-card-header>
        <mat-card-title class="card-title">{{ title }}</mat-card-title>
    </mat-card-header>
    
    <mat-card-content class="cam-card-content">
        <div #videoContainer></div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-raised-button (click)="takeSnapshot()" matTooltip="{{'webcam.add' | translate}}">
            <mat-icon>add_photo_alternate</mat-icon>
        </button>
        <button mat-raised-button (click)="disableVideo()" matTooltip="{{'webcam.closeandback' | translate}}">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-actions>
</mat-card>